import React, { Component } from 'react';
import { Layout, LocaleProvider } from 'antd';
import enUS from 'antd/lib/locale-provider/en_US';

import Topbar from '../Topbar/Topbar';

import AppHolder from './commonStyle';
import AppRouter from './AppRouter';
import './global.css';

const { Content, Footer } = Layout;

class Dashboard extends Component {
  render() {
    const { url } = this.props.match;
    return (
      <LocaleProvider locale={enUS}>
        <AppHolder>
          <Layout style={{ height: '100vh' }}>
            <Topbar />
            <Layout style={{ flexDirection: 'row', overflowX: 'hidden' }}>
              <Layout
                className="isoContentMainLayout"
                style={{
                  height: '100vh',
                }}
              >
                <Content
                  className="isomorphicContent"
                  style={{
                    padding: '70px 0 0',
                    flexShrink: '0',
                    background: '#f1f3f6',
                  }}
                >
                  <div className="boxed">
                    <AppRouter url={url} />
                  </div>
                </Content>
                <Footer
                  style={{
                    background: '#ffffff',
                    textAlign: 'center',
                    borderTop: '1px solid #ededed',
                  }}
                >
                  © 2017. Bestelapplicatie Demo ontwikkeld door
                  {' '}
                  <a
                    href="https://www.codens.be"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Codens
                  </a>
                  .
                </Footer>
              </Layout>
            </Layout>
          </Layout>
        </AppHolder>
      </LocaleProvider>
    );
  }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/components/App/App.js